@if(!isViewer) {
  <div class="wistia-modal-container">
    <div class="wistia-embed-wrapper">
      <div id="wistia_{{wistiaCode}}"
        aria-live="assertive"
        class="wistia_embed wistia_async_{{wistiaCode}}">
        &nbsp;
      </div>
    </div>
    <div *ngIf="isModal" class="control-bar">
      <zbp-button-component
        internalId="wistiaModalCloseButton"
        theme="primary"
        (clickHandler)="dismiss()"
        label="Close Video">
      </zbp-button-component>
    </div>
  </div>
} @else {
  <div id="{{wistiaCode}}" class="wistia_embed wistia_async_{{wistiaCode}} autoPlay=true wmode=transparent" [class.fullScreen]="isViewerFullScreen">
    &nbsp;
  </div>
}

